import { Link } from "react-router-dom";
import Section from "../Section/Section";
import { BLOG_POSTS } from "../../../data/blogPosts";
import { BiTime, BiCalendar, BiRightArrowAlt } from "react-icons/bi";
import SectionTitle from "../../common/SectionTitle";

function formatDate(dateStr: string): string {
  const date = new Date(dateStr + "T00:00:00");
  return date.toLocaleDateString("es-AR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export default function Blog() {
  const posts = BLOG_POSTS.slice(0, 3);

  return (
    <Section id="blog" className="w-full">
      <SectionTitle>Últimos artículos</SectionTitle>

      <div className="flex flex-col gap-4">
        {posts.map((post) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            className="group flex flex-col sm:flex-row gap-0 rounded-xl bg-gray-800/60 border border-gray-700/40 hover:border-gray-600/70 overflow-hidden transition-all duration-300 hover:shadow-lg hover:shadow-black/20"
          >
            {/* Cover image */}
            {post.coverImage && (
              <div className="sm:w-52 shrink-0 overflow-hidden">
                <img
                  src={post.coverImage.startsWith("/") || post.coverImage.startsWith("http") ? post.coverImage : `/${post.coverImage}`}
                  alt={`Portada: ${post.title}`}
                  className="w-full h-full object-cover aspect-[3/2] sm:aspect-auto transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
            )}

            {/* Content */}
            <div className="flex flex-col gap-2.5 p-4 flex-1">
              {/* Meta */}
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-500">
                <span className="flex items-center gap-1">
                  <BiCalendar size={13} />
                  {formatDate(post.date)}
                </span>
                <span className="flex items-center gap-1">
                  <BiTime size={13} />
                  {post.readingTime} min de lectura
                </span>
              </div>

              {/* Title */}
              <h3 className="text-white font-semibold leading-snug group-hover:text-green-300 transition-colors duration-200">
                {post.title}
              </h3>

              {/* Summary */}
              <p className="text-gray-400 text-sm leading-relaxed line-clamp-2 flex-1">
                {post.summary}
              </p>

              {/* Tags + read more */}
              <div className="flex flex-wrap items-center justify-between gap-2 pt-1">
                <div className="flex flex-wrap gap-1.5">
                  {post.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="text-xs bg-gray-700/60 text-gray-400 px-2 py-0.5 rounded-md border border-gray-700/40"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <span className="flex items-center gap-1 text-green-300 text-xs font-medium group-hover:gap-2 transition-all duration-200">
                  Leer artículo
                  <BiRightArrowAlt size={15} />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Always show "Ver todos" */}
      <div className="flex justify-center mt-6">
        <Link
          to="/blog"
          className="text-sm text-gray-500 hover:text-white transition-colors duration-200 underline underline-offset-4"
        >
          Ver todos los artículos →
        </Link>
      </div>
    </Section>
  );
}
